export default {
  'purchaseImport.form.xmlRecipient': 'Destinatário XML',
  'purchaseImport.form.xmlIssuer': 'Emitente XML',
  'purchaseImport.form.linkToExistingPurchase': 'Vincular a compra existente',

  'purchaseImport.error.incompatibleCompany':
    'O CNPJ informado é incompatível com a empresa cadastrada',

  'purchaseImport.form.company': 'Empresa',
  'purchaseImport.form.invoiceKey': 'Chave nota físcal',
  'purchaseImport.form.supplier': 'Fornecedor',
  'purchaseImport.form.invoiceNumber': 'Número da Nota Físcal',
  'purchaseImport.form.Model': 'Modelo',
  'purchaseImport.form.series': 'Série',
  'purchaseImport.form.emissionDate': 'Data de emissão',
  'purchaseImport.form.departureDate': 'Data de saída',
  'purchaseImport.form.noteValue': 'Valor da nota',

  'purchaseImport.form.message.error': 'Importe um arquivo',
  'purchaseImport.form.message.upload':
    'Selecione um arquivo para realizar a importação',
  'purchaseImport.form.message.import': 'Importar',
};
